module.exports = __webpack_public_path__ + "static/media/sprite.mp3.ab826a6.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprite.mp3.mp3
// module id = Xwq0
// module chunks = 1